import { IGeracaoDeMarcacoesPadraoHistoricoItemView } from './models/historico-geracao.model';

export class HistoricoGeracaoController {

    public opened = false;
    public items: IGeracaoDeMarcacoesPadraoHistoricoItemView[] = [];
    public loading = false;
    public loadError = false;
    public subtitle = '';
    public badgeLabel = '';
    public badgeClass = '';
    public onClose?: () => void;

    fechar() {
        if (this.onClose) {
            this.onClose();
        }
    }

    hasItems() {
        return !!this.items.length;
    }
}
